export default __webpack_public_path__ + "static/media/heading.9113b1f9.png";